import { ShieldAlert, ArrowLeft, Home } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth';

export function AccessDenied({ message }: { message?: string }) {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleReturnDashboard = () => {
    const role = (user?.role || '').toLowerCase().trim();
    if (role.includes('super admin') || role.includes('superadmin') || role === 'admin') {
      navigate('/admin/dashboard');
    } else if (role === 'manager') {
      navigate('/manager/dashboard');
    } else if (role === 'technician' || role.includes('technician') || role === 'agent' || role.includes('service desk')) {
      navigate('/technician/dashboard');
    } else if (role === 'viewer' || role === 'auditor') {
      navigate('/viewer/dashboard');
    } else {
      navigate('/user/dashboard');
    }
  };

  return (
    <div className="flex min-h-[80vh] w-full flex-col items-center justify-center p-6 text-center animate-in fade-in duration-300">
      <div className="flex h-20 w-20 items-center justify-center rounded-2xl bg-rose-500/10 text-rose-500 mb-6 shadow-sm border border-rose-500/20">
        <ShieldAlert className="h-10 w-10" />
      </div>
      
      <h1 className="font-display text-4xl font-bold tracking-tight text-foreground mb-2">
        403 — Access Denied
      </h1>
      
      <p className="text-base text-muted-foreground max-w-md mb-8">
        {message || 'You do not have permission to access this page.'}
      </p>

      <div className="flex flex-wrap items-center justify-center gap-3">
        <button
          onClick={() => navigate(-1)}
          className="inline-flex items-center gap-2 rounded-xl border border-border bg-card px-4 py-2.5 text-sm font-semibold text-foreground transition hover:bg-muted hover:border-primary/40 shadow-sm"
        >
          <ArrowLeft className="h-4 w-4" /> Go Back
        </button>
        
        <button
          onClick={handleReturnDashboard}
          className="inline-flex items-center gap-2 rounded-xl bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground transition hover:opacity-90 shadow-sm"
        >
          <Home className="h-4 w-4" /> Return to Dashboard
        </button>
      </div>

      <div className="mt-8 text-xs text-muted-foreground/70">
        If you believe you should have access to this resource, contact your system administrator.
      </div>
    </div>
  );
}
